import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';
import styles from './IndexDocumentHeader.scss';
import DateTime from 'common/components/DateTime/DateTime';
import { DEFAULT_DATETIME_INPUT_FORMAT } from 'common/util/dateTime';
import lodash from 'lodash';

const GoBackLink = ({ binder, indexingType, push, study }) => {

    const searchParams = (new URL(window.location)).searchParams;
    const from = searchParams.get('from');
    const docId = searchParams.get('docId');
    const isFromExpectations = from === 'expectations';
    const isFromUnfiledDocs = from === 'unfileddocs';
    const isFromDocumentList = from === 'documentList'; 
    const isFromDocumentView = from === 'documentView'; 

    const handleGoBackClick = (e) => {
        e.preventDefault();
        goBack();
    };

    const handleGoBackToStudy = (e) => {
        e.preventDefault();
        push(`/study/${study.id}/expectations`);
    };

    const handleGoBackToDocumentList = (e) => {
        e.preventDefault();
        push(`/study/${study.id}/documents`);
    };
    
    const handleGoBackToDocument = (e) => {
        e.preventDefault();
        push(`/study/${study.id}/files/${docId}`);
    };

    const handleGoBackToUnfiledDocs = () => {
        push(`/study/${study.id}/documents?folder=unfiled&o=-1&offset=0&q=&s=uploadDate`);
    };

    if (isFromExpectations) {
        return (
            <a href="#" className={styles.goBackLink} onClick={handleGoBackToStudy} data-cy="goBackLink">
                Go Back to Expectations
            </a>
        );
    }

    if (isFromUnfiledDocs) {
        return (
            <a href="#" className={styles.goBackLink} onClick={handleGoBackToUnfiledDocs} data-cy="goBackLink">
                Go Back to Unfiled Documents
            </a>
        );
    }

    if (isFromDocumentList) {
        return (
            <a href="#" className={styles.goBackLink} onClick={handleGoBackToDocumentList} data-cy="goBackLink">
                Go Back to Document List
            </a>
        );
    }

    if (isFromDocumentView && docId) {
        return (
            <a href="#" className={styles.goBackLink} onClick={handleGoBackToDocument} data-cy="goBackLink">
                Go Back to Document
            </a>
        );
    }

    // If its not any of the condition above, can assume its binder
    if (indexingType === 'initialIndex') {
        return (
            <a href="#" className={styles.goBackLink} onClick={e => {
                e.preventDefault();
                push(`/binder/${binder.id}`);
            }}
            data-cy="goBackSnippet">
                Go back to {binder.title}
            </a>
        );
    }

    // Default to a normal react go back link
    return (
        <a href="#" className={styles.goBackLink} onClick={handleGoBackClick} data-cy="goBackLink">
            Go Back
        </a>
    );
};

const UploadedIn = ({ indexingType, title }) => {
    if (indexingType !== 'initialIndex') {
        return null;
    }

    return (
        <span data-cy="uploadedInSnippet">
            <span> uploaded in </span>
            <span data-cy="uploadedInSnippet-title">
                {title}
            </span>
        </span>
    );
};

const AutonameElement = ({ autonameValue }) => {
    if (!autonameValue) {
        return null;
    }

    return (
        <span className={styles.autoNamer} data-cy="autonameElement">
            <span className={styles.spacer}> as </span>
            <strong className={styles.autoName}>{autonameValue}</strong>
        </span>
    );
};

const IndexDocumentHeader = ({
    autonameValue,
    document,
    binder,
    indexingType,
    push,
    study
}) => (
    <header className={styles.header} data-cy="IndexDocumentHeader-return">
        <div className={styles.description} data-cy="IndexDocumentHeader-goBackSnippet">
            <p data-cy="IndexDocumentHeader-p">
                <span>You are filing </span>
                <em className={styles.documentName}>{document.name}</em>
                <AutonameElement autonameValue={autonameValue}/>
                <UploadedIn indexingType={indexingType} title={binder.title}/>
            </p>
            <div className={styles.toolTip}>
                <div className={styles.text}>
                    <div className={styles.text}>
                        <p>Uploaded By: {document.uploadUser ? document.uploadUser.displayName : null}</p>
                        <p>Uploaded Date: {<DateTime value={document.uploadDate} inputFormat={DEFAULT_DATETIME_INPUT_FORMAT} time={false} applyTimezoneOffset={true} />}</p>
                    </div>
                    <div className={styles.triangle}></div>
                </div>
            </div>
        </div>
        <GoBackLink binder={binder} indexingType={indexingType} push={push} study={study}/>
    </header>
);

IndexDocumentHeader.propTypes = {
    autonameValue: PropTypes.string,
    document: PropTypes.shape({
        name: PropTypes.string.isRequired,
        uploadUser: PropTypes.shape({
            displayName: PropTypes.string.isRequired
        }).isRequired,
        uploadDate: PropTypes.string.isRequired
    }).isRequired,
    binder: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    }),
    study: PropTypes.shape({
        id: PropTypes.string,
    }),
    indexingType: PropTypes.string.isRequired
};

export default connect((state, props) => {
    return {
        study: {
            id: lodash.get(state, 'study.id'),
        }
    };
}, {
    push,
    goBack
})(IndexDocumentHeader);
